import { render, staticRenderFns } from "./course_teacherorder_management.vue?vue&type=template&id=faf70276&scoped=true&"
import script from "./course_teacherorder_management.vue?vue&type=script&lang=js&"
export * from "./course_teacherorder_management.vue?vue&type=script&lang=js&"
import style0 from "./course_teacherorder_management.vue?vue&type=style&index=0&id=faf70276&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf70276",
  null
  
)

export default component.exports